import React, {Fragment, useState, useEffect} from 'react'
import {useDispatch, useSelector} from "react-redux"
import DateFnsUtils from "@date-io/date-fns"

// Material-UI Cord
import {makeStyles, withStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import ToggleButton from '@material-ui/lab/ToggleButton'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'
import Divider from '@material-ui/core/Divider'
import Tooltip from '@material-ui/core/Tooltip'
import Fab from '@material-ui/core/Fab'

// Material-UI Icon
import SaveIcon from '@material-ui/icons/Save'

// Material-UI Element
import {MuiPickersUtilsProvider, KeyboardDatePicker} from "@material-ui/pickers"

// Custom Component
import {Alert} from '../Alert/Alert'
import ConfirmDialog from '../Dialog/ConfirmDialog'
import WebViewer from "../WebViewer/WebViewer"
import ViewCoverDrawingTable from './ViewCoverDrawingTable'

// Custom Style
// import {redColor, oceanBlueColor, grayColor, blackColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import {viewCoverFormStyle} from '../../styles/jss/components/drawingRegister/viewCoverFormStyle'

// Global Function
// import {getFile} from "../../global/getPropertyInfo"

// Fetch Data
import {getCoverType, getCoverDetail, updateCover} from '../../dataSource/drawingRegister'


// Custom Style (Typography)
const InboxTypography = withStyles({
	root: {
		"fontSize": 12,
		"fontWeight": 400,
		"color": "red",
	},
}) (Typography)


const useStyles = makeStyles(theme => viewCoverFormStyle(theme))

const ViewCoverForm = props => {
	const {selectedCoverRecord, setCoverRefash, annotSaveChangeAction, setAnnotSaveChangeAction} = props
	const classes = useStyles()
	const dispatch = useDispatch()

	// Redux Data
	// const relatedItemPropertyRedux = useSelector(state => state.relatedItemPropertyRedux)

	// State Variable
	const [coverTypeList, setCoverTypeList] = useState(null)
	const [coverDetailRecord, setCoverDetailRecord] = useState(null)
	const [coverDetailRecordProperty, setCoverDetailRecordProperty] = useState(null)
	const [validationErrors, setValidationErrors] = useState({})

	// Alert dialog contral state
	const [alertOpen, setAlertOpen] = useState(false)
	const [alertData, setAlertData] = useState({
		type: "",
		title: "",
		content: ""
	})

	// Confirm dialog contral State
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
	const [confirmDialogData, setConfirmDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		confirmAction: "",
		cancelAction: ""
	})


	// Set Alert Content
	const buildAlert = (data) => {
		setAlertData({
			type: data.type,
			title: data.title,
			content: data.content
		})
		setAlertOpen(true)
	}

	// Set Confirm Dialog Content
	const buildConfirmDialog = (data) => {
		setConfirmDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			confirmAction: data.confirmAction,
			cancelAction: data.cancelAction
		})
	}

	// Input Control
	const handleTextChange = event => {
		const {name, value} = event.target
		const res = {...coverDetailRecordProperty}
		res[name] = value

		setCoverDetailRecordProperty(res)
		validate(res)
	}

	const handleIssueDateChange = date => {
		const res = {...coverDetailRecordProperty}
		res.issue_date = date

		setCoverDetailRecordProperty(res)
		validate(res)
	}


	// Confirm Dialog Control Function
	const confirmDialogHandleOpen = (data) => {
		buildConfirmDialog(data)
		setConfirmDialogOpen(true)
	}

	const confirmDialogHandleClose = () => {
		setConfirmDialogOpen(false)
	}


	// Action
	const updateCoverConfirmAction = () => {
		if (validate()) {
			confirmDialogHandleOpen({
				dialogTitle: "Update Cover Record",
				dialogContent: "Are you sure to save change.",
				confirmAction: updateCoverAction,
				cancelAction: updateCoverCancelAction
			})
		}
	}


	const updateCoverAction = () => {
		updateCover(coverDetailRecord.cover_seq, coverDetailRecordProperty).then(res => {
			confirmDialogHandleClose()
			
			if (res.type === "success") {
				setCoverRefash(res.code)
				
				buildAlert({
					// Alert Type: success, info, warning, error
					type: "success",
					title: "Success Alert",
					content: "The cover record have been updated"
				})

				// setTimeout(() => {
				// 	viewRelatedItemDialogHandleClose()
				// }, 2000)
			}
			else {
				buildAlert({
					// Alert Type: success, info, warning, error
					type: "error",
					title: "Error Alert",
					content: res.message
				})
			}
		}).catch(error => {
			buildAlert({
				// Alert Type: success, info, warning, error
				type: "error",
				title: "Error Alert",
				content: error.message
			})
		})
	}


	const updateCoverCancelAction = () => {
		confirmDialogHandleClose()
	}


	// Input Validation
	const validate = (fieldValues = coverDetailRecordProperty) => {
		let temp = {...validationErrors}
	
		if ("cover_no" in fieldValues) {
			temp.cover_no = fieldValues.cover_no ? "" : "This field is required"
		}

		if ("cover_subject" in fieldValues) {
			temp.cover_subject = fieldValues.cover_subject ? "" : "This field is required"
		}

		if ("issue_date" in fieldValues) {
			temp.issue_date = fieldValues.issue_date ? "" : "This field is required"
		}

		setValidationErrors({...temp})

		if (fieldValues == coverDetailRecordProperty) {
			return Object.values(temp).every(x => x == "")
		}
	}

	
	useEffect(() => {
		getCoverType().then(res => {
			setCoverTypeList(res)
		})
		.catch(error => {
			console.error("Get cover type list error: ", error)
		})

		getCoverDetail(selectedCoverRecord.cover_seq).then(res => {
			setCoverDetailRecord(res.data[0])
			setCoverDetailRecordProperty(res.data[0])
		})
		.catch(error => {
			console.error("Get cover detail record error: ", error)
		})
	}, [])


	return (
		// console.log("Selected Cover Record | Variable: selectedCoverRecord (viewCoverForm.js)"),
		// console.log(selectedCoverRecord),

		// console.log("Cover Type Record | Variable: coverTypeList (viewCoverForm.js)"),
		// console.log(coverTypeList),

		// console.log("Cover Detail Record Information | Variable: coverDetailRecord (viewCoverForm.js)"),
		// console.log(coverDetailRecord),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<div>
				<Alert
					open={alertOpen}
					alertType={alertData.type}
					alertTitle={alertData.title}
					alertContent={alertData.content}
					handleClose={() => setAlertOpen(false)}
				/>

				<ConfirmDialog
					open={confirmDialogOpen}
					dialogTitle={confirmDialogData.dialogTitle}
					dialogContent={confirmDialogData.dialogContent}
					confirmAction={confirmDialogData.confirmAction}
					cancelAction={confirmDialogData.cancelAction}
				/>

				{/* <FullScreenDialog
					open={fileManagerDialogOpen}
					dialogTitle={"File Choice From eFiling"}
					formContent={
						<Efiling fileManagerType={"select"} />   // main => Main File Manager, select => Select File From File Manager
					}
					button={fileManagerDialogBtn}
					handleClose={fileManagerDialogHandleClose}
				/> */}

				{/* <FullScreenDialog
					open={filePreviewDialogOpen}
					dialogTitle={"Drawing Preview"}
					formContent={
						<FilePreview 
							filePreviewProperty={filePreviewProperty}
						/>
					}
					button={[]}
					handleClose={filePreviewDialogHandleClose}
				/> */}
			</div> 

			{
				coverDetailRecord ?
					<Grid container spacing={1} className={classes.fieldGridArea}>
						<Grid item xs={12} sm={12} lg={6}>
							
							<Grid container spacing={1} className={classes.fieldGrid}>
								<Grid item xs={12} sm={12} lg={12}>
									<ToggleButtonGroup
										aria-label="Cover Type"
										exclusive
										value={coverDetailRecord.type_seq}
										// onChange={handleCoverType}
										className={classes.ToggleButtonGroup}
									>
										{
											coverTypeList && coverTypeList.length > 0 ?
												coverTypeList.map((res, index) => {
													return (
														<ToggleButton
															key={index}
															aria-label={res.type_name}
															disabled
															value={res.type_seq}
															className={classes.ToggleButton_33}
														>
															<Typography color="textSecondary">{res.type_name}</Typography>
														</ToggleButton>
													)
												})
											: ""
										}
									</ToggleButtonGroup>
								</Grid>
							</Grid>

							<Grid item xs={12} sm={12} lg={12} className={classes.fieldGrid}>
								<TextField
									id="cover_no"
									name="cover_no"
									label="Cover No."
									required
									fullWidth={true}
									size="small"
									variant="outlined"
									value={coverDetailRecordProperty ? coverDetailRecordProperty.cover_no : ""}
									onChange={handleTextChange}
									InputLabelProps={{
										shrink: true,
									}}
									error={validationErrors.cover_no && validationErrors.cover_no !== "" ? true : false}
									helperText={validationErrors.cover_no}
								/>
							</Grid>

							<Grid item xs={12} sm={12} lg={12} className={classes.fieldGrid}>
								<TextField
									id="cover_subject"
									name="cover_subject"
									label="Cover Subject"
									required
									fullWidth={true}
									size="small"
									variant="outlined"
									value={coverDetailRecordProperty ? coverDetailRecordProperty.cover_subject : ""}
									onChange={handleTextChange}
									InputLabelProps={{
										shrink: true,
									}}
									error={validationErrors.cover_subject && validationErrors.cover_subject !== "" ? true : false}
									helperText={validationErrors.cover_subject}
								/>
							</Grid>

							<Grid item xs={12} sm={12} lg={12} className={classes.fieldGrid}>
								<MuiPickersUtilsProvider utils={DateFnsUtils}>
									<KeyboardDatePicker
										id="issue_date"
										name="issue_date"
										label="Issue Date"
										required
										format="dd/MM/yyyy"
										placeholder="DD/MM/YYYY"
										size="small"
										inputVariant="outlined"
										KeyboardButtonProps={{
											"aria-label": "change date"
										}}

										className={classes.datePickerField}
										value={coverDetailRecordProperty ? coverDetailRecordProperty.issue_date : null}
										onChange={handleIssueDateChange}
										InputLabelProps={{
											shrink: true,
										}}
										error={validationErrors.issue_date && validationErrors.issue_date !== "" ? true : false}
										helperText={validationErrors.issue_date}
									/>
								</MuiPickersUtilsProvider>
							</Grid>

							<Grid item xs={12} sm={12} lg={12} className={classes.fieldGrid}>
								<Tooltip title="Save">
									<Fab 
										color="primary"
										size="small"
										onClick={updateCoverConfirmAction}
										className={classes.toolMenuBtn}
									>
										<SaveIcon />
									</Fab>
								</Tooltip>
							</Grid>

							<Grid item xs={12} sm={12} lg={12} className={classes.fieldGrid}>
								<Divider />
							</Grid>

							<Grid item xs={12} sm={12} lg={12} className={classes.fieldGrid}>
								<ViewCoverDrawingTable
									coverDrawingRecord={coverDetailRecord.drawings}
									annotSaveChangeAction={annotSaveChangeAction}
									setAnnotSaveChangeAction={setAnnotSaveChangeAction}
								/>
							</Grid>
						</Grid>

						<Grid item xs={12} sm={12} lg={6}>
							<WebViewer
								property={{
									from: "API",
									autoLoading: true,
									file_cat: coverDetailRecord.file_cat,
									file_ref: coverDetailRecord.cover_seq,
									file_name: coverDetailRecord.cover_no + ".pdf",
									
								}}
							/>
						</Grid>
					</Grid>

				: ""
			}
		</Fragment>
	)
}


export default ViewCoverForm